// extracted by mini-css-extract-plugin
module.exports = {"page-spinner":"style_page-spinner__SF7XP"};